// extracted by mini-css-extract-plugin
export default {"section-qualifications__row--full-width":"section-qualifications__row--full-width--jWAmw","sectionQualificationsRowFullWidth":"section-qualifications__row--full-width--jWAmw"};